import { render } from "./KarriereBox.vue?vue&type=template&id=b3807bb0"
import script from "./KarriereBox.vue?vue&type=script&lang=ts"
export * from "./KarriereBox.vue?vue&type=script&lang=ts"

import "./KarriereBox.vue?vue&type=style&index=0&id=b3807bb0&lang=scss"
script.render = render

export default script